import { request } from 'shared/lib/request';

export const unsubscribeUserService = (payload) =>
  request.post('/me/unsubscribe', payload);
